app.service('permissionsBox', function (localStorage, modal, agreementsSubmit, html) {
	let $self, $form;

	function minimalize() {
		html.add('permissions-minimalize');
		localStorage.setItem('permissions-minimalize', true);
	}
	function maximalize() {
		html.remove('permissions-minimalize');
		localStorage.removeItem('permissions-minimalize');
	}
	function more() {
		$self.addClass('more');
	}
	function less() {
		$self.removeClass('more');
	}
	function permissionsSuccessClose() {
		$self.hide();
	}
	function clickCheckbox() {
		const id = $(this).data('id');
		$form.find('input:checkbox[data-id=' + id + ']').prop('checked', true);
		sign({
			permissions: [{
				definitionId: id,
				selected: true
			}]
		});
	}
	function sign(data) {
		$self.addClass('loading');
		agreementsSubmit.send();
		$.ajax({
			data: JSON.stringify(data),
			contentType: "application/json",
			dataType: "json",
			type: 'POST',
			url: '/customer-update-permissions.ltr',
			success: function () {
				$self.removeClass('loading').addClass('signed');
			},
			error: function () {
				$self.removeClass('loading');
				modal.alert('Bład zapisu zgody. Prosimy spróbować później');
			}
		});
	}
	function checkPermissions() {
		if (localStorage.getItem('permissions-minimalize')) {
			minimalize();
		}
	}
	function init() {
		$self = $('#permissions-box');
		$form = $('#agreements-form');
		if ($self.length) {
			$('body')
				.on('click', '.js-permissions-minimalize', minimalize)
				.on('click', '.js-permissions-maximalize', maximalize)
				.on('click', '.js-permissions-more', more)
				.on('click', '.js-permissions-less', less)
				.on('click', '.js-permissions-sign', clickCheckbox)
				.on('click', '.js-permissions-success-close', permissionsSuccessClose);
			if ($form.length) {
				$form.find('input:checkbox').prop('checked', false);
				agreementsSubmit.init($form, $form.find('input:checkbox'));
			}
		}
		checkPermissions();
	}

	return {
		init,
		checkPermissions
	};
});
